// import {Route, Routes, Navigate} from 'react-router-dom';
// import ResetPassword from './ResetPassword';
// import Chat from "./Chat";
// import AuthForm from "./AuthForm";
// import PrivateRoute from "./PrivateRoute";
// import ForgottenPassword from "./ForgottenPassword";
//
// // Pages d'administration
// import AdminDashboard from './admin/AdminDashboard';
// import UsersPage from './admin/UsersPage';
// import QuotasPage from './admin/QuotasPage';
// import StatsPage from './admin/StatsPage';
// import PaymentsPage from './admin/PaymentsPage';
// import SettingsPage from './admin/SettingsPage';
// import AdminOverview from './admin/AdminOverview';
//
// const isAdmin = localStorage.getItem('isAdmin') === 'true';
//
// if (!isAdmin) {
//     return <Navigate to="/login" replace />;
// }
//
// return children;
// };
//
//
// const AppRoutes = () => (
//     // <Router>
//         <Routes>
//             <Route path="/reset-password/:token" element={<ResetPassword/>} />
//             {/* Route protégée */}
//             <Route path="/" element={<PrivateRoute element={Chat} />} />
//             {/* Route pour la connexion */}
//             <Route path="/login" element={<AuthForm />} />
//             <Route path="/forgot-password" element={<ForgottenPassword/>} />
//         </Routes>
//     // </Router>
//
//
// );
//
// export default AppRoutes;
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ResetPassword from './ResetPassword';
import ChatContainer from "./ChatContainer";
import AuthForm from "./AuthForm";
import PrivateRoute from "./PrivateRoute";
import ForgottenPassword from "./ForgottenPassword";
import DomainsPage from './admin/DomainsPage';
import DomainDetailPage from './admin/DomainDetailPage';

// Pages d'administration
import AdminDashboard from './admin/AdminDashboard';
import UsersPage from './admin/UsersPage';
import QuotasPage from './admin/QuotasPage';
import StatsPage from './admin/StatsPage';
import PaymentsPage from './admin/PaymentsPage';
import SettingsPage from './admin/SettingsPage';
import AdminOverview from './admin/AdminOverview';
import AdminRoute from './AdminRoute';

const AppRoutes = () => (
    <Routes>
        {/* Routes publiques */}
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/login" element={<AuthForm />} />
        <Route path="/forgot-password" element={<ForgottenPassword />} />

        {/* Route pour le chat (protégée) */}
        <Route path="/" element={<PrivateRoute element={ChatContainer} />} />

        {/* Routes d'administration - protégées */}
        <Route path="/admin" element={<AdminRoute element={AdminDashboard} />}>
            <Route index element={<AdminOverview />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="domains" element={<DomainsPage />} />
            <Route path="domains/:id" element={<DomainDetailPage />} />
            <Route path="quotas" element={<QuotasPage />} />
            <Route path="stats" element={<StatsPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Route par défaut */}
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);

export default AppRoutes;